import React from 'react';
import PerfectScrollbar from 'react-perfect-scrollbar';
import useBackgrounds from '../../hooks/useBackgrounds';
import usePoses from '../../hooks/usePoses';
import styles from '../PackageBuilders/MultiPose/MultiPose.module.scss';
import 'react-perfect-scrollbar/dist/css/styles.css';

export default function ScrollbarTest() {
  const { data: backgrounds } = useBackgrounds(534);
  const { data: poses } = usePoses(641630, 534);

  const onClick = () => { };

  return (
    <>
      <div className={styles.carousel}>
        <div className={styles.carouselHeader}>
          <p>Click to Select</p>
        </div>
        <PerfectScrollbar>
          <div className={styles.carouselItemsPerfect}>
            {backgrounds.map((item) => (
              <button
                className={styles.carouselItem}
                key={item.id}
                onClick={() => onClick(item)}
                type="button"
              >
                <img src={item.watermarkUrl || item.imageUrl} />
              </button>
            ))}
          </div>
        </PerfectScrollbar>
      </div>
      <div className={styles.carousel}>
        <div className={styles.carouselHeader}>
          <p>Click to Select</p>
        </div>
        <PerfectScrollbar>
          <div className={styles.carouselItemsPerfect}>
            {poses.map((item) => (
              <button
                className={styles.carouselItem}
                key={item.id}
                onClick={() => onClick(item)}
                type="button"
              >
                <img src={item.watermarkUrl || item.imageUrl} />
              </button>
            ))}
          </div>
        </PerfectScrollbar>
      </div>
    </>
  );
}
